var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Desktop","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Menu","fill":"#212121"},[React.createElement("circle",{"id":"Oval","cx":"3","cy":"3","r":"3","key":0}),React.createElement("circle",{"id":"Oval","cx":"3","cy":"13","r":"3","key":1}),React.createElement("circle",{"id":"Oval","cx":"3","cy":"23","r":"3","key":2})])));
}

Hamburger.defaultProps = {"viewBox":"0 0 6 26","version":"1.1"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
